<template>
  <div>
    <TheHeader></TheHeader>
    <BreadcrumbBar/>
    <PageHeader full>
      <TextHeading variant="subtitle" color="secondary">Corporate</TextHeading>
      <TextHeading variant="xl">Investor Centre</TextHeading>
    </PageHeader>
    <InvestorsBanner/>
    <PageGrid>
      <PageMain>
        <PageSection>
          <Cards>
            <CardsCol>
              <CardLink
                title="Q3 Trading Statement"
                link="Regulatory News"
                category="Announcements"
              ></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="Find out more about our upcoming events"
                link="View Calendar"
                category="Financial Calendar"
              ></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="Get an indicitive valuation of your shareholding"
                category="Shareholder Services"
              ></CardLink>
            </CardsCol>
          </Cards>
        </PageSection>
        <StatsBar/>
        <PageSection title="Downloads: Half Year Results Announcement">
          <Cards>
            <CardsCol>
              <CardDownload title="Full Annual Report 2018/2019"/>
            </CardsCol>
            <CardsCol>
              <CardDownload title="Corporate Responsibility 2018/2019"/>
            </CardsCol>
            <CardsCol>
              <CardDownload title="Strategic Report 2018/2019"/>
            </CardsCol>
          </Cards>
        </PageSection>
        <PageSection title="Latest News">
          <Cards>
            <CardsCol>
              <CardLink title="Board Members Biographies" category="Leadership"></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="Learn more about our history and key milestones that goes over three lines"
                category="Company Info"
              ></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="Official photos, logos and assets for download"
                category="Media Assets"
              ></CardLink>
            </CardsCol>
          </Cards>
        </PageSection>
      </PageMain>
    </PageGrid>
    <TheFooter></TheFooter>
  </div>
</template>

<script>
import CardsCol from '../elements/CardsCol.vue'
import TheFooter from '../components/TheFooter.vue'
import CardLink from '../components/CardLink.vue'
import CardDownload from '../components/CardDownload.vue'
import Cards from '../elements/Cards.vue'
import StatsBar from '../components/StatsBar.vue'
import PageSection from '../elements/PageSection.vue'
import PageMain from '../elements/PageMain.vue'
import PageGrid from '../elements/PageGrid.vue'
import InvestorsBanner from '../components/InvestorsBanner.vue'
import TextHeading from '../elements/TextHeading.vue'
import PageHeader from '../components/PageHeader.vue'
import BreadcrumbBar from '../components/BreadcrumbBar.vue'
import TheHeader from '../components/TheHeader.vue'
export default {
  name: 'PageInvestors',
  components: {
    TheHeader,
    BreadcrumbBar,
    PageHeader,
    TextHeading,
    InvestorsBanner,
    PageGrid,
    PageMain,
    PageSection,
    Cards,
    CardLink,
    StatsBar,
    CardDownload,
    TheFooter,
    CardsCol
  },
  methods: {
    handleClick(url) {
      window.location.href = url
    }
  }
}
</script>